import React from 'react';

export default function PhoneWithDot() {
  return (
    <svg width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
      <g fill="none">
        <path
          d="M3.64683424 4c-.1119882 0-.22697608.019-.33796438.059l-2.646721.949c-.4049573.144-.682928.534-.66093032.96.11698767 2.124.76091979 4.095 1.79081122 5.812 1.08188595 1.78 2.57472859 3.286 4.36054037 4.376 1.74581596 1.059 3.7736022 1.713 5.94237357 1.842.018998.001.0369961.002.0559941.002.4249552 0 .8029154-.291.9309019-.697l.872908-2.779c.1679823-.534-.1469845-1.099-.6919271-1.245l-2.7467105-.731c-.0859909-.023-.1729817-.034-.2579728-.034-.31796644 0-.62293429.152-.81191437.418l-.77191863 1.086-4.82149178-4.803 1.09388469-.822c.3209662-.242.46395113-.652.35996209-1.039l-.69992625-2.621C4.48774559 4.288 4.08378818 4 3.64683424 4m-.00399958 1.002l.7029259 2.591-1.09388469.823c-.23197554.174-.37596037.44-.39695815.73-.0199979.289.08699083.573.29196922.778l4.82149177 4.803c.18898008.187.44295331.291.70592559.291.02799705 0 .0559941-.001.08399115-.003.29296911-.026.56094086-.178.73092295-.417l.7689189-1.084 2.741711.711L12.1549374 17c-1.9467948-.115-3.84259494-.703-5.48242208-1.697-1.63182798-.997-3.02468119-2.395-4.022576-4.036-.99089554-1.652-1.54583704-3.453-1.64982608-5.318l2.64272142-.947"
          fill="#162D3D"
        />
        <circle fill="#60BC57" cx="9.5" cy="2.5" r="2.5" />
      </g>
    </svg>
  );
}

PhoneWithDot.displayName = 'PhoneWithDot';
